import gp from '@sagold/json-pointer';
import {
  Change,
  Editor,
  isJsonError,
  Node,
  Plugin,
  setValue,
} from '@sagold/react-json-editor';

import {
  calculateSum,
  CustomNode,
  getCustomNode,
  isChangeEvent,
} from './pluginHelper';

function updateSum(
  draft: Editor['draft'],
  rootNode: Node,
  sumNode: CustomNode
): [Node, Change[]] | [] {
  const summands = sumNode.schema.summands as string[];

  const pointersToLookUp = summands.map((pointer) =>
    gp.join(sumNode.pointer, '..', pointer)
  );
  const sum = calculateSum(pointersToLookUp, rootNode, sumNode);

  if (!Number.isNaN(sum) && sum !== sumNode.value) {
    const [newRoot, newChanges] = setValue(
      draft,
      rootNode,
      sumNode.pointer,
      sum
    );
    if (!isJsonError(newRoot)) {
      return [newRoot, newChanges ?? []];
    }
  }
  return [];
}

export const SumPlugin: Plugin = (he) => {
  return {
    id: 'sum-plugin',
    onEvent(root, event) {
      if (!isChangeEvent(event)) {
        return undefined;
      }
      let currentRoot = root;
      const changes: Change[] = [];
      for (const sum of getCustomNode(root, 'summands')) {
        const [nextRoot, nextChanges] = updateSum(he.draft, currentRoot, sum);
        if (nextRoot && nextChanges) {
          currentRoot = nextRoot;
          changes.push(...nextChanges);
        }
      }
      return changes.length > 0 ? [currentRoot, changes] : undefined;
    },
  };
};
